// extracted by mini-css-extract-plugin
export default {"page":"DetailsAndDocuments_page__B6BU3","content":"DetailsAndDocuments_content__HcGVp","actions":"DetailsAndDocuments_actions__dUmGO"};